/**
 * Use this middleware to check notification
 */
import store from "../store";

export default async (to, from, next) => {
  store.dispatch("notification/loadNotifications");
  next();
};
